import { render } from "./Create.vue?vue&type=template&id=0b7cd1b2&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import "./Create.vue?vue&type=style&index=0&id=0b7cd1b2&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/LBP/mi-stock-lbp-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7cd1b2"]])

export default __exports__